import React from "react";

import { Layout } from "antd";
import { useLocation } from "react-router-dom";

import Headers from "./header/header";
import Footers from "./footer/Footer";

const { Header, Footer, Content } = Layout;
function Layouts({ children }) {
  const location = useLocation();
  const isChatPath = location.pathname.includes("chat");

  return (
    <Layout>
      <Header>
        <Headers />
      </Header>
      <Content
        style={{
          backgroundColor: "white",
        }}
      >
        {children}
      </Content>
      {!isChatPath &&
        <Footer
          style={{
            backgroundColor: "white",
          }}
        >
          <Footers />
        </Footer>
      }

    </Layout>
  );
}

export default Layouts;
